import React, { ChangeEvent, useContext, useState } from "react";
import ISerial from "../../../models/ISerial";
import { OwIconButton } from "../../shared/OwIconButton/OwIconButton";
import { OwFnInput } from "../../shared/OwFnInput/OwFnInput";
import OwButton from "../../shared/OwButton/OwButton";
import IOrder_ItemUI from "../../../models/IOrder_ItemUI";
import IOrderEntryProcessSerialDTO from "../../../models/DTO/IOrderEntryProcessSerialDTO";
import UserContext from "../../../contexts/UserContext";
import SupplierContext from "../../../contexts/SupplierContext";

type Props = {
    row: IOrder_ItemUI;
    serial: ISerial;
    saveFn: (data: IOrderEntryProcessSerialDTO) => void;
    readOnly: boolean;
};

export const OrderEntryEditSerial = (props: Props) => {
    const userModel = useContext(UserContext);
    const supplierModel = useContext(SupplierContext);

    const [serial, setSerial] = useState(props.serial);
    const [editMode, setEditMode] = useState(false);
    const [preEditModeSerial, setPreEditModeSerial] = useState(props.serial);

    const deleteSerial = () => {
        const payload: IOrderEntryProcessSerialDTO = {
            serialId: serial.id,
            serial: serial.value,
            userToken: userModel.token,
            userGuid: userModel.guid,
            supplierGuid: supplierModel.guid,
            orderItemGuid: props.row.guid,
            deleteFlag: true,
        };

        props.saveFn(payload);
    };

    const editSerial = () => {
        setEditMode(!editMode);
        setPreEditModeSerial(serial);
    };

    const handleRowSerial = (e: ChangeEvent<any>) => {
        const value = e.target.value;

        const _serial = {
            ...serial,
            value,
        };

        setSerial(_serial);
    };

    const saveSerial = () => {
        const payload: IOrderEntryProcessSerialDTO = {
            serialId: serial.id,
            serial: serial.value,
            userToken: userModel.token,
            userGuid: userModel.guid,
            supplierGuid: supplierModel.guid,
            orderItemGuid: props.row.guid,
        };

        props.saveFn(payload);
    };

    const cancelSave = () => {
        setSerial(preEditModeSerial);
        setEditMode(false);
    };

    return (
        <div className={"OrderEntryEditSerial"}>
            <div>
                {editMode || props.readOnly ? null : (
                    <span>
                        <OwIconButton iconClass={"fa fa-trash-alt"} iconColorClass={"text-danger me-2"} fn={deleteSerial} />
                        <OwIconButton iconClass={"fa fa-pencil-alt"} iconColorClass={"text-primary me-2"} fn={editSerial} />
                    </span>
                )}
                {editMode ? (
                    <div className={"d-flex"}>
                        <div className={"w-15r"}>
                            <OwFnInput value={serial.value} fn={handleRowSerial} name={"serial"} />
                        </div>
                        <div>
                            <OwButton title={"save"} fn={saveSerial} className={"btn-primary ms-2"} />
                            <OwButton title={"cancel"} fn={cancelSave} className={"btn-danger ms-2"} />
                        </div>
                    </div>
                ) : (
                    serial.value
                )}
            </div>
        </div>
    );
};
